import React from 'react';
import styled from 'styled-components';

const ButtonElement = styled.button`
  background-color: ${props => (props.color ? props.color : '#edba5d')};
  border: none;
  color: #ffffff;
  display: inline-block;
  font-size: 20px;
  padding: 20px;
  &:hover {
    background-color: ${props =>
      props.color ? props.color + 90 : '#edba5d90'};
    cursor: pointer;
  }
`;

const Button = ({ title, color, ...rest }) => {
  return (
    <ButtonElement color={color} {...rest}>
      {title}
    </ButtonElement>
  );
};
export default Button;
